/**
 * Placeholder page — M1 scaffolding only.
 * Every route in §F1 exists from M1 so the topbar nav works end to end; the views
 * themselves land in their own milestones (§K). Delete a usage when its feature ships.
 */
import { useTranslation } from 'react-i18next';

export interface PlaceholderProps {
  title: string;
  body: string;
  /** §K milestone label, e.g. "M5". */
  milestone: string;
}

export function Placeholder({ title, body, milestone }: PlaceholderProps) {
  const { t } = useTranslation();
  return (
    <div className="view placeholder">
      <div>
        <h2>{title}</h2>
        <p>{body}</p>
        <span className="ms">{t('placeholder.milestone', { milestone })}</span>
      </div>
    </div>
  );
}

export default Placeholder;
